import axios from 'axios';

import {SurveyRouterData} from '../components/survey/surveyRoutesHelpers';
import {VersionsEnum} from './version';

export async function postSurvey(
  routerData: SurveyRouterData,
  score: number,
  note?: string,
  contact?: string,
) {
  switch (routerData.version) {
    case VersionsEnum.V1:
      return await postSurveyV1(routerData, score, note, contact);
    case VersionsEnum.V2:
      return await postSurveyV2(routerData, score, note, contact);
    default:
      throw new Error('unknown route version');
  }
}

async function postSurveyV2(routerData: SurveyRouterData, score: number, note?: string, contact?: string) {
  const prefix = `api/1/noauth/companies/${routerData.slug}/survey/v2`;

  return await axios({
    method: 'post',
    url: `https://app.frontapp.com/${prefix}/response`,
    data: {
      msg_uid: routerData.msgUid,
      company_slug: routerData.slug,
      score,
      note,
      contact_handle: contact,
    },
  });
}

async function postSurveyV1(routerData: SurveyRouterData, score: number, note?: string, contact?: string) {
  const prefix = `api/1/noauth/companies/${routerData.slug}/survey`;

  return await axios({
    method: 'post',
    url: `https://app.frontapp.com/${prefix}/response`,
    data: {
      token: routerData.token,
      score,
      note,
      contact_handle: contact,
    },
  });
}
